<template>
    <div class="reo-tip" @mouseout="show = false" @mousemove="show = true">
        <span class="icon-icon_question tip-icon" @click="show = true"></span>
        <div class="content" v-show="show">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {

    mounted () {

        $( 'body' ).on( 'touchstart', this.touchstart );

    },

    destroyed () {

        $( 'body' ).unbind( 'touchstart', this.touchstart );

    },

    data () {

        return {

            show: false

        };

    },

    methods: {

        touchstart ( e ) {

            let outSide = $( e.target ).parents( '.reo-tip' ).length === 0;
            if ( outSide && this.show ) {

                this.show = false;

            }

        }

    }

};
</script>

<style scoped lang="less">
.reo-tip{
    position: relative;
    display: inline-block;
    z-index: 2;
    font-size: 0;
    vertical-align: middle;
}
.tip-icon{
    color: #000;
    font-size: 0.2rem;
    cursor: pointer;
}
.content{
    position: absolute;
    left: 50%;
    top: 50%;
    padding: 0.1rem;
    box-sizing: border-box;
    width: 3rem;
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #777;
    border-radius: 0.05rem;
    font-size: 0.16rem;
    /* display: none; */
    text-align: left;
    color: #fff;
    font-weight: 400;
    @media @mobile{
        font-size: 0.26rem;
    }
}
.content a{
    color: #fff;
    text-decoration: underline;
    &:hover{
        .text{
            border: none;
        }
    }
}
.content p{
    margin: 0;
}
/* .reo-tip:hover .content{
    display: block !important;
} */
.content a .ui-icon{
    transform: scale(0.5) translateY(36%);
    display: inline-block;
}
@media @mobile {
    .tip-icon{
        font-size: 0.38rem;
    }
    div.content p{
        font-size: 0.24rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/Tip.vue